// Catalog of ReHub Studio apps that can be credited on a share demo
// ("Created with ..."). Logos are absolute URLs hosted on each app's own
// domain, so they load fine cross-origin on the public share page.
// Keep in sync with apps/hub/constants.ts.

import type { ShareDemoWorkflowType } from './types';

export interface ShareDemoApp {
  id: string;
  name: string;
  url: string;
  logo: string;
  // Per-logo visual scale to even out artwork with different internal padding
  // (defaults to 1). e.g. a wordmark with lots of transparent margin needs >1.
  logoScale?: number;
}

export const SHARE_DEMO_APPS: ShareDemoApp[] = [
  {
    id: 'photoclear',
    name: 'Photoclear AI',
    url: 'https://photoclear.rehub.studio',
    logo: 'https://photoclear.rehub.studio/Photoclear%20Logo%20HR%20Trans.png',
    logoScale: 1.5,
  },
  {
    id: 'hyperdusk',
    name: 'Hyper Dusk',
    url: 'https://hyperdusk.rehub.studio',
    logo: 'https://hyperdusk.rehub.studio/hyperdusk-logo-wordmark-alpha.png',
    logoScale: 1.8,
  },
  {
    id: 'imagemotion',
    name: 'ImageMotion AI',
    url: 'https://imagemotion.rehub.studio',
    logo: 'https://imagemotion.rehub.studio/Logo.webp',
    logoScale: 0.9,
  },
  {
    id: 'staging',
    name: 'Virtual Staging Studio',
    url: 'https://staging.rehub.studio',
    logo: 'https://staging.rehub.studio/virtual-staging-logo-transparent.png',
    logoScale: 1.5,
  },
  {
    id: 'tours',
    name: '360 Tours',
    url: 'https://360tours.rehub.studio',
    logo: 'https://360tours.rehub.studio/360tours-studio-logo-transparent.png',
    logoScale: 1.4,
  },
];

export const getShareDemoApp = (id: string): ShareDemoApp | undefined =>
  SHARE_DEMO_APPS.find((a) => a.id === id);

/** Canonical public origin for each share-demo workflow. */
export const SHARE_DEMO_BASE_URL: Record<ShareDemoWorkflowType, string> = {
  photoclear: 'https://photoclear.rehub.studio',
  staging: 'https://staging.rehub.studio',
  hyperdusk: 'https://hyperdusk.rehub.studio',
  video: 'https://photoclear.rehub.studio',
  tour: 'https://360tours.rehub.studio',
};

export const getShareDemoUrl = (workflow: ShareDemoWorkflowType, slug: string): string =>
  `${SHARE_DEMO_BASE_URL[workflow]}/share/${slug}`;

export const getShareDemoHost = (workflow: ShareDemoWorkflowType): string =>
  new URL(SHARE_DEMO_BASE_URL[workflow]).host;
